<template>
  <layout>
    <section id="explain" class="explain">
      <b-container>
        <div class="intro">
          <h2>{{ $t('pages.faq.title') }}</h2>
        </div>
      </b-container>
      <div v-html="$t('pages.faq.text')" />
    </section>
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';

  export default {
    name: 'Faq',
    components: {
      Layout,
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>



// WEBPACK FOOTER //
// src/views/Default/Faq.vue